const $productSubmit = $('.js-product-submit');
const $countOutput = $('.js-cart-items-count');
const $outputRelatedProducts = $('.js-output-related-products');
const $cartNotification = $('.cart-notification');

const productSubmit = {
  initialize() {
    if (!$productSubmit.length) {
      return;
    }

    $(document).on('submit', '.js-product-submit', (e) => {
      e.preventDefault();
      this.submit(e.currentTarget);
    });
  },

  submit(target) {
    const $target = $(target);
    this.sendCartUpdate($target.attr('action'), $target.serialize());
    this.getRelatedProducts('/api/related-products', $target.serialize());
    this.sendGaAddToCart($target);
  },

  toggleCartNotification() {
    $cartNotification.addClass('is-visible');

    setTimeout(() => {
      $cartNotification.removeClass('is-visible');
    }, 2000);
  },

  sendCartUpdate(action, serializedData) {
    $.ajax({
      url: action,
      type: 'POST',
      data: serializedData,
      dataType: 'json',
      success: (res) => {
        const itemsCount = res.items_count;

        this.outputCount(itemsCount);
        this.toggleCartNotification();
      },
    });
  },

  getRelatedProducts(action, serializedData) {
    $.ajax({
      url: action,
      type: 'POST',
      data: serializedData,
      success: (res) => {
        $outputRelatedProducts.html(res);
      },
    });
  },

  sendGaAddToCart($target) {
    if (typeof window.dataLayer === 'undefined') {
      return;
    }

    // Retrieve product information from the data attribute
    const ga4Data = $target[0].getAttribute('data-ga4');

    // Check that the product information JSON object seems valid
    if (!ga4Data || ga4Data.indexOf('{') !== 0) {
      return;
    }

    // Retrieve the quantity from an input element in the form (if available)
    const $quantity = $target.find('[name="quantity"]');
    const quantity = $quantity.length ? parseInt($quantity.val(), 10) : 1;

    const item = JSON.parse(ga4Data);

    let value = (item.price ?? 0);

    // If quantity is defined, and its numeric
    if (typeof quantity !== 'undefined' && !Number.isNaN(parseInt(quantity, 10))) {
      item.quantity = parseInt(quantity, 10);
      value *= item.quantity;
    }

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: 'EUR',
        value,
        items: [item],
      },
    });
  },

  outputCount(count) {
    if (Number.isNaN(parseInt(count, 10))) {
      return;
    }

    $countOutput.text(parseInt(count, 10));
  },
};

export default productSubmit;
